import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postSponsor } from "../../store/sponsor/actions";
export var useSponsorCreate = function (trigger, body) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) { return ({
        responsePostSponsor: state.Sponsor.responsePostSponsor,
        errorPostSponsor: state.Sponsor.errorPostSponsor,
        loadingPostSponsor: state.Sponsor.loadingPostSponsor,
    }); }), responsePostSponsor = _a.responsePostSponsor, errorPostSponsor = _a.errorPostSponsor, loadingPostSponsor = _a.loadingPostSponsor;
    useEffect(function () {
        if (trigger) {
            dispatch(postSponsor(body));
        }
    }, [trigger]);
    return {
        responsePostSponsor: responsePostSponsor,
        errorPostSponsor: errorPostSponsor,
        loadingPostSponsor: loadingPostSponsor,
    };
};
